import React from 'react'
import "./Skills.css"



import Dummy from './Dummy'


export default function Skills() {

  return (
    <div className='skills-wrapper' id='Skills'>

      <header className="page-header">
        <h1 className="home-title"><strong>Skills</strong></h1>
      </header>
      <Dummy/>
    </div>
  )
}
